// https://github.com/JedWatson/react-input-autosize/blob/master/src/AutosizeInput.js
import React from "react";

const sizerStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    visibility: "hidden",
    height: 0,
    overflow: "scroll",
    whiteSpace: "pre",
};
const copyStyles = (styles, node) => {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
};

class AutosizeInput extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            inputWidth: props.minWidth,
            autosizeValue: props.value,
        };

    }

    componentDidMount() {
        this.mounted = true;
        this.copyInputStyles();
        this.updateInputWidth();

    }

    componentDidUpdate() {
        this.updateInputWidth();

    }

    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //
    //     console.log(this.props);
    //     console.log(nextProps);
    //     return false;
    // }

    focus() {
        this.input.focus();
    }

    blur() {
            this.input.blur();
    }

    reset = () => {

    };

    select() {
        this.input.select();
    }

    sizerRef = (el) => {
        this.sizer = el;
    };

    getCurrentValue = () => {
        // return this.state;
        return this.props.value;
    };

    inputRef = (el) => {
        this.input = el;
    };

    updateInputWidth() {
        if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === "undefined") {
            return;
        }
        let newInputWidth;
        if (this.props.placeholder && (!this.props.value || (this.props.value && this.props.placeholderIsMinWidth))) {
            newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 12;
        } else {
            newInputWidth = this.sizer.scrollWidth + 12;
        }
        // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
        const extraWidth = (this.props.type === "number" && this.props.extraWidth === undefined)
            ? 16 : parseInt(this.props.extraWidth) || 0;
        newInputWidth += extraWidth;
        if (newInputWidth < this.props.minWidth) {
            newInputWidth = this.props.minWidth;
        }
        if (newInputWidth !== this.state.inputWidth) {
            this.setState({
                inputWidth: newInputWidth,
            });
        }
    }

    copyInputStyles() {
        if (!this.mounted || !window.getComputedStyle) {
            return;
        }
        const inputStyles = this.input && window.getComputedStyle(this.input);
        if (!inputStyles) {
            return;
        }
        copyStyles(inputStyles, this.sizer);
    }

    updateInputValue = () => {
        if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === "undefined") {
            return;
        }
        let newInputWidth;
        if (this.props.placeholder && (!this.props.value || (this.props.value && this.props.placeholderIsMinWidth))) {
            newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
        } else {
            newInputWidth = this.sizer.scrollWidth + 2;
        }
        // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
        const extraWidth = (this.props.type === "number" && this.props.extraWidth === undefined)
            ? 16 : parseInt(this.props.extraWidth) || 0;
        newInputWidth += extraWidth;
        if (newInputWidth < this.props.minWidth) {
            newInputWidth = this.props.minWidth;
        }
        if (newInputWidth !== this.state.inputWidth) {
            this.setState({
                inputWidth: newInputWidth,
            });
        }
    };

    render() {

        const inputStyle = {
            boxSizing: "content-box",
            width: `${this.state.inputWidth}px`,
        };
        const {

            handleFocusClass = () => {
            },
            ...inputProps
        } = this.props;

        // TODO: doh, there must be a better way
        delete inputProps.placeholder;
        delete inputProps.minWidth;
        delete inputProps.showLabel;
        delete inputProps.errorName;
        delete inputProps.translations;
        delete inputProps.isInFocus;
        delete inputProps.places;
        delete inputProps.property;
        delete inputProps.showFancyOverlay;
        inputProps.style = inputStyle;
        const sizerValue = this.props.value;
        return (
            <div>
                <input ref={this.inputRef}
                    placeholder={""}
                    {...inputProps}
                    onFocus={() => {
                        handleFocusClass();
                    }}
                    id={this.props.name}
                    className={`${this.props.isInFocus ? "tms-input-has-focus" : "tms-input-has-no-focus"} ${this.props.className}`}
                    data-tms-name={this.props.name}
                    tabIndex={0}
                    autoComplete="off"
                    type={inputProps.type || "text"}

                />
                <div ref={this.sizerRef} style={sizerStyle}>{sizerValue}</div>
            </div>

        );
    }
}

export default React.memo(AutosizeInput);

AutosizeInput.defaultProps = {
    minWidth: 1,
};
